import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { Fragment, useState, useEffect } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Fetcher from '../../../libs/Petition';
import ButtonIcon from '../../Layouts/Forms/ButtonIcon';
import SkeletonCards from '../../Layouts/Skeletons/Cards';
import GanaLogo from '../../../images/gana2.png';
import { useTranslation } from 'react-i18next';

const Clients = (props) => {
    const { showConfig } = props;

    const [t, i18n] = useTranslation('global');
    const prefix = 'super-admin.tooltips';
    const token = useSelector(state => state.login.token);
    const headers = { Authorization: `Bearer ${token}` };
    const [fibras, setFibras] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getFibras(headers);
    }, []);

    const getFibras = async () => {
        try {
            let response = await Fetcher({
                method: 'GET',
                url: `/fibras`,
                headers
            });
            setFibras(response.data.data);
        } catch (error) {
            setFibras([]);
        }
        setLoading(false);
    }

    return (
        <Fragment>
            {
                loading ?
                    <SkeletonCards items={4} cols={4} /> :
                    <Row xs={1} md={4} className="g-4 mt-2">
                        {
                            fibras && fibras.map((fibra, index) => (
                                <Col key={index}>
                                    <Card>
                                        <Card.Img variant="top" src={GanaLogo} />
                                        <Card.Body>
                                            <Card.Title>{fibra.code}</Card.Title>
                                            <Card.Text>{fibra.name}</Card.Text>
                                            <div id='footer-options'>
                                                <ButtonIcon icon={faEdit} variant='outline-success' tooltip={t(`${prefix}.edit-admin`)}
                                                    onClick={() => showConfig(fibra)} />
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))
                        }
                    </Row>
            }
        </Fragment>

    );
}

export default Clients;